/**
 * Automatically remove $0 products from cart
 * Runs on page load and after cart updates
 */

(function() {
  'use strict';

  /**
   * Remove zero price items from cart
   */
  function removeZeroPriceItems() {
    // Fetch current cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (!cart || !cart.items || cart.items.length === 0) {
          return;
        }

        // Find all items with price 0
        const zeroPriceItems = cart.items.filter(item => item.price === 0);
        
        if (zeroPriceItems.length === 0) {
          return;
        }

        console.log('Found ' + zeroPriceItems.length + ' zero price item(s) in cart, removing...');

        // Remove each zero price item
        const removePromises = zeroPriceItems.map(item => {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        });

        // Wait for all removals to complete
        return Promise.all(removePromises);
      })
      .then(results => {
        if (results && results.length > 0) {
          console.log('Removed ' + results.length + ' zero price item(s) from cart');
          
          // Refresh cart display
          refreshCartDisplay();
          
          // Dispatch custom event for cart update
          if (window.Shopify && window.Shopify.theme) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        }
      })
      .catch(error => {
        console.error('Error removing zero price items from cart:', error);
      });
  }

  /**
   * Refresh cart display after items are removed
   */
  function refreshCartDisplay() {
    // Trigger cart drawer refresh if it exists
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    if (cartDrawer) {
      // Dispatch event to refresh cart drawer
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    // Update cart count in header
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });

        // Update cart icon badge
        const cartBadges = document.querySelectorAll('.cart-count-bubble, [data-cart-badge]');
        cartBadges.forEach(badge => {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        });
      })
      .catch(error => {
        console.error('Error updating cart display:', error);
      });
  }

  /**
   * Initialize - run on page load
   */
  function init() {
    // Run immediately on page load
    removeZeroPriceItems();

    // Listen for cart updates
    document.addEventListener('cart:updated', function() {
      setTimeout(removeZeroPriceItems, 100);
    });

    // Listen for Shopify cart API events if available
    if (window.Shopify && window.Shopify.theme) {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(removeZeroPriceItems, 100);
      });
    }

    // Listen for custom cart refresh events
    document.addEventListener('cart:refresh', function() {
      setTimeout(removeZeroPriceItems, 100);
    });

    // Also check when cart drawer opens
    const cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');
    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        setTimeout(removeZeroPriceItems, 500);
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after a short delay to catch any async cart loads
  setTimeout(removeZeroPriceItems, 1000);

})();

